import { useAppSelector } from '@/shared/hooks';

import { organizationModel } from '@/entities/organization';
import { isReport2D, reportsModel } from '@/entities/reports';

export const useFDA2DRestrictions = () => {
  const { isFDA } = useAppSelector(
    organizationModel.selectors.selectFDAEnvironment,
  );

  const isSettingsLoaded = useAppSelector(
    organizationModel.selectors.selectRelevantOrganizationSettingsLoaded,
  );

  const currentReportType = useAppSelector(
    reportsModel.selectors.selectCurrentReportType,
  );

  const isRestrictionContextReady =
    isSettingsLoaded && currentReportType !== undefined;

  const isFDA2DReport = isFDA && isReport2D(currentReportType);

  return {
    isFDA2DReport,
    shouldHideSuspiciousTeethToggle:
      !isRestrictionContextReady || isFDA2DReport,
    shouldHideConditionDetailsToggle:
      !isRestrictionContextReady || isFDA2DReport,
    shouldRestrictPrint: isFDA2DReport,
  };
};
